import { ITool } from '@/creditflowresearch/domain/vo/ITools';
import { AbsProduct, HycProduct } from '@/creditflowresearch/domain/Product';
import { MARKET_OVERVIEW_ALL, NEW_ISSUE_STATS } from '@/creditflowresearch/domain/Header/Tool/constants';

const TOOL_DISPLAY_OVERRIDES: Record<string, string> = {
  [NEW_ISSUE_STATS]: 'Stats',
};

export interface IGetToolNameOptions {
  id: string,
  isABSProduct: boolean,
  name: string,
  additionalName?: string | null,
}

class ToolNameResolver {
  static resolveDisplayName(
    tool: ITool,
    productAbbreviation: string,
  ): string {
    const override = TOOL_DISPLAY_OVERRIDES[tool.id];
    if (override) {
      return override;
    }

    const isMarketOverview = tool.id === MARKET_OVERVIEW_ALL;
    const isAbsProduct = productAbbreviation === AbsProduct.ABBREVIATION;

    const baseName = isMarketOverview && !isAbsProduct
      ? 'Market Overview'
      : tool.name;

    return tool.additionalName
      ? `${ baseName } (${ tool.additionalName })`
      : baseName;
  }

  static resolve(options: IGetToolNameOptions): string {
    const productAbbreviation = options.isABSProduct
      ? AbsProduct.ABBREVIATION
      : HycProduct.ABBREVIATION;

    return ToolNameResolver.resolveDisplayName(
      {
        id: options.id,
        name: options.name,
        additionalName: options.additionalName,
      },
      productAbbreviation,
    );
  }
}

export default ToolNameResolver;
